'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
exports.Operation = void 0;
var tslib_1 = require('tslib');
var react_1 = (0, tslib_1.__importDefault)(require('react'));
var useOperation_1 = require('../hooks/useOperation');
function Operation(_a) {
    var children = _a.children,
        operationId = _a.operationId;
    var operation = (0, useOperation_1.useOperation)({ operationId: operationId, suspense: true });
    return react_1.default.createElement(react_1.default.Fragment, null, children(operation));
}
exports.Operation = Operation;
